import { Component } from "@kluntje/core";
import { addClass, findAll, find, removeClass } from "@kluntje/js-utils/lib/dom-helpers";
import { ACTIVE } from "Helper/cssClasses";

/**
 * Custom Element to
 */
class FRAList extends Component {
  constructor() {
    super({
      ui: {
        footnote: ".fra-js-list__desc-footnote",
        overlay: ".fra-js-overlay:-one",
      },

      events: [
        {
          event: "click",
          target: "footnote",
          handler: "handleClick",
        },
      ],
    });
  }

  /**
   * opens the clicked footnote inside an overlay
   * @param {Event} e
   */
  handleClick(e: Event): void {
    e.preventDefault();
    this.ui.overlay.open();
    const activeFootnoteID = (e.currentTarget as HTMLAnchorElement).hash;
    const allFootnotes = findAll(this.ui.overlay, ".fra-e-list__footnotes");
    removeClass(allFootnotes, ACTIVE);
    const activeFootnote = find(this.ui.overlay, activeFootnoteID);
    addClass(activeFootnote, ACTIVE);
  }
}

customElements.define("fra-e-list", FRAList);

export default FRAList;
